import { Descriptions } from "@/components/v2";
import { Card } from "@rumbledirect/ui";
import { type DescriptionsProps } from "antd";
import { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";
import { getMapsLink } from "@/lib/helpers/links";

interface VehicleHandInLocationCardProps {
  dossier: Dossier | undefined;
  isLoading?: boolean;
}

export const VehicleHandInLocationCard = ({
  dossier,
  isLoading,
}: VehicleHandInLocationCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Locatie naam",
      children: dossier?.vehicleHandInLocationName,
    },
    {
      label: "Adres",
      children: dossier?.vehicleHandInLocationAddress ? (
        <>
          <a
            href={getMapsLink({
              address: dossier.vehicleHandInLocationAddress,
            })}
            target="_blank"
            rel="noopener noreferrer"
          >
            {`${dossier.vehicleHandInLocationAddress.street} ${dossier.vehicleHandInLocationAddress.streetNumber}${dossier.vehicleHandInLocationAddress.streetNumberAddition || ""}`}{" "}
            <br />
            {dossier.vehicleHandInLocationAddress.postalCode}{" "}
            {dossier.vehicleHandInLocationAddress.city}{" "}
            {dossier.vehicleHandInLocationAddress.country ? (
              <>
                <br />
                {dossier.vehicleHandInLocationAddress.country}
              </>
            ) : null}
          </a>
        </>
      ) : null,
    },
  ];

  // Don't render the card if there's no location data
  if (
    !dossier?.vehicleHandInLocationName &&
    !dossier?.vehicleHandInLocationAddress
  ) {
    return null;
  }

  return (
    <Card loading={isLoading} className="w-full" title="Inleverlocatie">
      <Descriptions items={items} />
    </Card>
  );
};
